<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>/Brooklyn.NY/web_developer</h2>
    <p>./electrons_and_light_flow_throughout_the_universe</p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  font-family: 'Quicksand', sans-serif;
  margin: 20px 0 0;
  font-style: italic;
  font-size: 15px;
  color: #00b8ff;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
h1, h2 {
  font-weight: 100;
}
h1 {
  color: #ffeccc;
  font-family: 'Quicksand', sans-serif;
  font-style: italic;
}
h2 {
  color: #e49d22;
}
</style>
